import { BASE_INPUT_SIZE } from '../VBaseInput/variable';
import inputTwStyle from '../VInput/style';
import { createTwStyle, joinCn } from '../util';
import type { VSelectProps } from './type';

const twStyle = createTwStyle<Pick<VSelectProps, 'size'>>();

export default twStyle({
  arrowIcon: ({ size }) => [
    joinCn({
      'size-4': size === BASE_INPUT_SIZE.SM,
      'size-5.5': size === BASE_INPUT_SIZE.MD,
      'size-6': size !== BASE_INPUT_SIZE.SM && size !== BASE_INPUT_SIZE.MD,
    }),
  ],

  displayValue: ({ size }) => [
    joinCn(inputTwStyle({ size }).input, 'cursor-pointer outline-none'),
  ],
});
